import React, { useState, useEffect } from 'react';
import { apiRequest } from '../utils/api';
import EditVPS from './EditVPS';

const VPSDetails = ({ vps, onBack, onVPSUpdated, onVPSDeleted }) => {
  const [vpsData, setVpsData] = useState(vps);
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [copiedProviderPwd, setCopiedProviderPwd] = useState(false);

  useEffect(() => {
    fetchVPSDetails();
  }, [vps._id]);

  const fetchVPSDetails = async () => {
    setLoading(true);
    try {
      const data = await apiRequest(`/admin/vps/${vps._id}`);
      if (data && data.success) {
        setVpsData(data.data);
      }
    } catch (error) {
      console.error('Error fetching VPS details:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('هل أنت متأكد من حذف هذا الخادم VPS؟')) {
      return;
    }

    try {
      const data = await apiRequest(`/admin/vps/${vps._id}`, {
        method: 'DELETE',
      });

      if (data.success) {
        if (onVPSDeleted) onVPSDeleted();
      } else {
        alert(data.message || 'حدث خطأ أثناء حذف الخادم');
      }
    } catch (error) {
      alert('حدث خطأ في الاتصال بالخادم');
      console.error('Error deleting VPS:', error);
    }
  };

  if (editMode) {
    return (
      <EditVPS
        vps={vpsData}
        onUpdate={(updatedVPS) => {
          setVpsData(updatedVPS);
          setEditMode(false);
          if (onVPSUpdated) onVPSUpdated(updatedVPS);
        }}
        onCancel={() => setEditMode(false)}
      />
    );
  }

  if (loading) {
    return (
      <div className="loading">
        <div className="loading-spinner"></div>
        جاري التحميل...
      </div>
    );
  }

  return (
    <div>
      <div className="card">
        <div className="card-header">
          <h2 className="card-title">تفاصيل خادم VPS</h2>
          <div style={{ display: 'flex', gap: '1rem' }}>
            <button className="btn btn-primary btn-sm" onClick={() => setEditMode(true)}>
              تعديل
            </button>
            <button className="btn btn-danger btn-sm" onClick={handleDelete}>
              حذف
            </button>
            <button className="btn btn-secondary btn-sm" onClick={onBack}>
              رجوع
            </button>
          </div>
        </div>

        <div style={{ padding: '1.5rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1.5rem', marginBottom: '2rem' }}>
            <div>
              <strong>IP Address:</strong>
              <p style={{ marginTop: '0.5rem', fontSize: '1.1rem' }}>{vpsData.ip}</p>
            </div>
            <div>
              <strong>Nickname:</strong>
              <p style={{ marginTop: '0.5rem' }}>{vpsData.nickname || '—'}</p>
            </div>
            <div>
              <strong>User:</strong>
              <p style={{ marginTop: '0.5rem', fontSize: '1.1rem' }}>{vpsData.user}</p>
            </div>
            <div>
              <strong>Password:</strong>
              <p style={{ marginTop: '0.5rem', fontFamily: 'monospace' }}>••••••••</p>
            </div>
            <div>
              <strong>Port:</strong>
              <p style={{ marginTop: '0.5rem' }}>{vpsData.port || '22'}</p>
            </div>
            <div>
              <strong>Provider:</strong>
              <p style={{ marginTop: '0.5rem' }}>{vpsData.provider || '—'}</p>
            </div>
            <div>
              <strong>Provider User:</strong>
              <p style={{ marginTop: '0.5rem' }}>{vpsData.providerUser || '—'}</p>
            </div>
            <div>
              <strong>Provider Password:</strong>
              <div style={{ marginTop: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span style={{ fontFamily: 'monospace' }}>{vpsData.providerPassword ? '••••••••' : '—'}</span>
                {vpsData.providerPassword && (
                  <button
                    className={`btn btn-outline-secondary btn-sm ${copiedProviderPwd ? 'btn-success' : ''}`}
                    onClick={() => {
                      const pwd = vpsData.providerPassword || '';
                      if (!pwd) return;
                      navigator.clipboard.writeText(pwd).then(() => {
                        setCopiedProviderPwd(true);
                        setTimeout(() => setCopiedProviderPwd(false), 1500);
                      }).catch(() => {
                        setCopiedProviderPwd(false);
                      });
                    }}
                  >
                    {copiedProviderPwd ? '✓ تم النسخ' : '📋 نسخ كلمة المرور'}
                  </button>
                )}
              </div>
            </div>
            <div>
              <strong>Start Date:</strong>
              <p style={{ marginTop: '0.5rem' }}>
                {vpsData.startDate
                  ? new Date(vpsData.startDate).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })
                  : '—'}
              </p>
            </div>
            <div>
              <strong>End Date:</strong>
              <p style={{ marginTop: '0.5rem' }}>
                {vpsData.endDate
                  ? new Date(vpsData.endDate).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })
                  : '—'}
              </p>
            </div>
            <div>
              <strong>Status:</strong>
              <p style={{ marginTop: '0.5rem' }}>
                <span className={`badge ${vpsData.isActive ? 'badge-success' : 'badge-danger'}`}>
                  {vpsData.isActive ? 'نشط' : 'غير نشط'}
                </span>
              </p>
            </div>
            <div>
              <strong>عدد العملاء:</strong>
              <p style={{ marginTop: '0.5rem' }}>
                <span className="badge badge-info">{vpsData.customerCount || 0}</span>
              </p>
            </div>
          </div>

          {vpsData.notes && (
            <div style={{ marginBottom: '2rem' }}>
              <strong>Notes:</strong>
              <p style={{ marginTop: '0.5rem', whiteSpace: 'pre-wrap' }}>{vpsData.notes}</p>
            </div>
          )}
        </div>
      </div>

      {/* Connected Customers */}
      {vpsData.customers && vpsData.customers.length > 0 && (
        <div className="card" style={{ marginTop: '1.5rem' }}>
          <div className="card-header">
            <h3 className="card-title">العملاء المرتبطين ({vpsData.customers.length})</h3>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table className="table">
              <thead>
                <tr>
                  <th>الاسم</th>
                  <th>البريد الإلكتروني</th>
                  <th>نوع النشاط</th>
                  <th>الحالة</th>
                </tr>
              </thead>
              <tbody>
                {vpsData.customers.map((customer) => (
                  <tr key={customer._id}>
                    <td>{customer.name}</td>
                    <td>{customer.email}</td>
                    <td>
                      {customer.businessType === 'electronics' ? 'إلكترونيات' :
                       customer.businessType === 'clothes' ? 'ملابس' :
                       customer.businessType === 'home-accessories' ? 'إكسسوارات منزلية' :
                       '—'}
                    </td>
                    <td>
                      <span className={`badge ${customer.isActive ? 'badge-success' : 'badge-danger'}`}>
                        {customer.isActive ? 'نشط' : 'غير نشط'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default VPSDetails;
